"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[4831],{

/***/ 2305:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7294);
var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



var SvgPencil = function SvgPencil(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "pencil_svg__h-5 pencil_svg__w-5",
    viewBox: "0 0 20 20",
    fill: "currentColor"
  }, props), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M17.414 2.586a2 2 0 0 0-2.828 0L7 10.172V13h2.828l7.586-7.586a2 2 0 0 0 0-2.828z"
  })), _path2 || (_path2 = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    fillRule: "evenodd",
    d: "M2 6a2 2 0 0 1 2-2h4a1 1 0 0 1 0 2H4v10h10v-4a1 1 0 1 1 2 0v4a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V6z",
    clipRule: "evenodd"
  })));
};

/* harmony default export */ __webpack_exports__["Z"] = (SvgPencil);

/***/ }),

/***/ 7700:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7294);
var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



var SvgUser = function SvgUser(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "user_svg__h-6 user_svg__w-6",
    fill: "none",
    viewBox: "0 0 24 24",
    stroke: "currentColor",
    strokeWidth: 2
  }, props), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M16 7a4 4 0 1 1-8 0 4 4 0 0 1 8 0zm-4 7a7 7 0 0 0-7 7h14a7 7 0 0 0-7-7z"
  })));
};

/* harmony default export */ __webpack_exports__["Z"] = (SvgUser);

/***/ }),

/***/ 8875:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "h": function() { return /* binding */ DropdownItem; },
  "Z": function() { return /* binding */ dropdown; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/@floating-ui/react-dom-interactions/dist/floating-ui.react-dom-interactions.esm.js + 2 modules
var floating_ui_react_dom_interactions_esm = __webpack_require__(4287);
// EXTERNAL MODULE: ./node_modules/@floating-ui/core/dist/floating-ui.core.browser.min.mjs
var floating_ui_core_browser_min = __webpack_require__(8301);
// EXTERNAL MODULE: ./node_modules/@floating-ui/dom/dist/floating-ui.dom.browser.min.mjs
var floating_ui_dom_browser_min = __webpack_require__(5863);
// EXTERNAL MODULE: ./node_modules/@headlessui/react/dist/components/menu/menu.js
var menu = __webpack_require__(2510);
// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(6010);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
;// CONCATENATED MODULE: ./src/utils/constants.ts
/* provided dependency */ var process = __webpack_require__(3454);
const isInMaintenanceMode = process.env.MAINTENANCE_MODE === "true";
const transformOriginByPlacement = {
    bottom: "origin-top",
    "bottom-end": "origin-top-right",
    "bottom-start": "origin-top-left",
    left: "origin-right",
    "left-start": "origin-top-right",
    "left-end": "origin-bottom-right",
    right: "origin-left",
    "right-start": "origin-top-left",
    "right-end": "origin-bottom-left",
    top: "origin-bottom",
    "top-start": "origin-bottom-left",
    "top-end": "origin-bottom-right"
};

// EXTERNAL MODULE: ./src/utils/stop-propagation.ts
var stop_propagation = __webpack_require__(6708);
;// CONCATENATED MODULE: ./src/components/dropdown.tsx







const Dropdown = (param)=>{
    let { children , className , trigger , placement: preferredPlacement  } = param;
    const { reference , floating , x , y , strategy , placement , refs , update  } = (0,floating_ui_react_dom_interactions_esm/* useFloating */.YF)({
        strategy: "fixed",
        placement: preferredPlacement,
        middleware: [
            (0,floating_ui_core_browser_min/* offset */.cv)(5),
            (0,floating_ui_core_browser_min/* flip */.RR)()
        ]
    });
    const animationOrigin = transformOriginByPlacement[placement];
    react.useEffect(()=>{
        if (!refs.reference.current || !refs.floating.current) {
            return;
        }
        // Only call this when the floating element is rendered
        return (0,floating_ui_dom_browser_min/* autoUpdate */.Me)(refs.reference.current, refs.floating.current, update);
    }, [
        refs.reference,
        refs.floating,
        update
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(menu/* Menu */.v, {
        children: (param)=>/*#__PURE__*/ {
            let { open  } = param;
            return (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(menu/* Menu.Button */.v.Button, {
                        as: "div",
                        className: className,
                        ref: reference,
                        children: trigger
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(floating_ui_react_dom_interactions_esm/* FloatingPortal */.ll, {
                        children: open ? /*#__PURE__*/ (0,jsx_runtime.jsx)(menu/* Menu.Items */.v.Items, {
                            className: (0,clsx_m/* default */.Z)("z-50 animate-popIn divide-gray-100 rounded-md bg-white p-1 shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none", animationOrigin),
                            onMouseDown: stop_propagation/* stopPropagation */.U,
                            ref: floating,
                            style: {
                                position: strategy,
                                left: x !== null && x !== void 0 ? x : "",
                                top: y !== null && y !== void 0 ? y : ""
                            },
                            children: children
                        }) : null
                    })
                ]
            });
        }
    });
};
const DropdownItem = (param)=>{
    let { icon: Icon , label , onClick , disabled , href  } = param;
    const Element = href ? "a" : "button";
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(menu/* Menu.Item */.v.Item, {
        disabled: disabled,
        children: (param)=>/*#__PURE__*/ {
            let { active  } = param;
            return (0,jsx_runtime.jsxs)(Element, {
                href: href,
                onClick: onClick,
                className: (0,clsx_m/* default */.Z)("group flex w-full items-center rounded py-2 pl-2 pr-4", {
                    "bg-primary-500 text-white": active,
                    "text-gray-700": !active,
                    "opacity-50": disabled
                }),
                children: [
                    Icon && /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon, {
                        className: (0,clsx_m/* default */.Z)("mr-2 h-5 w-5", {
                            "text-white": active,
                            "text-primary-500": !active
                        })
                    }),
                    label
                ]
            });
        }
    });
};
/* harmony default export */ var dropdown = (Dropdown);


/***/ }),

/***/ 4831:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "$": function() { return /* binding */ MobileNavigation; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(6010);
// EXTERNAL MODULE: ./node_modules/framer-motion/dist/es/components/AnimatePresence/index.mjs + 3 modules
var AnimatePresence = __webpack_require__(1190);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(1664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/next-i18next/dist/esm/index.js + 36 modules
var esm = __webpack_require__(692);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
;// CONCATENATED MODULE: ./src/components/logo.tsx


const Logo = (props)=>{
    const { color =true  } = props;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
        className: (0,clsx_m/* default */.Z)("font-semibold uppercase tracking-widest", {
            "text-primary-500": color
        }, props.className),
        children: "Rallly"
    });
};

// EXTERNAL MODULE: ./src/components/modal/modal-provider.tsx + 3 modules
var modal_provider = __webpack_require__(366);
// EXTERNAL MODULE: ./src/components/user-provider.tsx
var user_provider = __webpack_require__(7348);
// EXTERNAL MODULE: ./src/components/auth/login-form.tsx
var login_form = __webpack_require__(6260);
;// CONCATENATED MODULE: ./src/components/auth/login-modal.tsx







const LoginModal = (param)=>{
    let { onDone  } = param;
    const [hasAccount, setHasAccount] = react.useState(false);
    const [defaultEmail, setDefaultEmail] = react.useState("");
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "w-[420px] max-w-full overflow-hidden rounded-lg bg-white shadow-sm",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "bg-pattern border-b border-t-4 border-t-primary-500 bg-slate-500/5 p-4 text-center sm:p-8",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Logo, {
                    className: "text-2xl"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "p-4 sm:p-6",
                children: hasAccount ? /*#__PURE__*/ (0,jsx_runtime.jsx)(login_form/* RegisterForm */.B, {
                    defaultValues: {
                        email: defaultEmail
                    },
                    onRegistered: onDone,
                    onClickLogin: (e)=>{
                        e.preventDefault();
                        setHasAccount(false);
                    }
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(login_form/* LoginForm */.U, {
                    onAuthenticated: onDone,
                    onClickRegister: (e, email)=>{
                        e.preventDefault();
                        setDefaultEmail(email);
                        setHasAccount(true);
                    }
                })
            })
        ]
    });
};
const useLoginModal = ()=>{
    const modalContext = (0,modal_provider/* useModalContext */.v)();
    const { refresh  } = (0,user_provider/* useUser */.aF)();
    const openLoginModal = ()=>{
        modalContext.render({
            overlayClosable: false,
            showClose: true,
            content: function Content(param) {
                let { close  } = param;
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(LoginModal, {
                    onDone: ()=>{
                        refresh();
                        close();
                    }
                });
            },
            footer: null
        });
    };
    return {
        openLoginModal
    };
};
const LoginLink = (param)=>{
    let { children , className  } = param;
    const { openLoginModal  } = useLoginModal();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
        href: "/login",
        onClick: (e)=>{
            e.preventDefault();
            openLoginModal();
        },
        className: className,
        children: children
    });
};

;// CONCATENATED MODULE: ./src/components/icons/adjustments.svg
var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



var SvgAdjustments = function SvgAdjustments(props) {
  return /*#__PURE__*/react.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "adjustments_svg__h-6 adjustments_svg__w-6",
    fill: "none",
    viewBox: "0 0 24 24",
    stroke: "currentColor",
    strokeWidth: 2
  }, props), _path || (_path = /*#__PURE__*/react.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M12 6V4m0 2a2 2 0 1 0 0 4m0-4a2 2 0 1 1 0 4m-6 8a2 2 0 1 0 0-4m0 4a2 2 0 1 1 0-4m0 4v2m0-6V4m6 6v10m6-2a2 2 0 1 0 0-4m0 4a2 2 0 1 1 0-4m0 4v2m0-6V4"
  })));
};

/* harmony default export */ var adjustments = (SvgAdjustments);
;// CONCATENATED MODULE: ./src/components/icons/home.svg
var home_path;

function home_extends() { home_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return home_extends.apply(this, arguments); }



var SvgHome = function SvgHome(props) {
  return /*#__PURE__*/react.createElement("svg", home_extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "home_svg__h-6 home_svg__w-6",
    fill: "none",
    viewBox: "0 0 24 24",
    stroke: "currentColor",
    strokeWidth: 2
  }, props), home_path || (home_path = /*#__PURE__*/react.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m3 12 2-2m0 0 7-7 7 7M5 10v10a1 1 0 0 0 1 1h3m10-11 2 2m-2-2v10a1 1 0 0 1-1 1h-3m-6 0a1 1 0 0 0 1-1v-4a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v4a1 1 0 0 0 1 1m-6 0h6"
  })));
};

/* harmony default export */ var home = (SvgHome);
;// CONCATENATED MODULE: ./src/components/icons/login.svg
var login_path;

function login_extends() { login_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return login_extends.apply(this, arguments); }



var SvgLogin = function SvgLogin(props) {
  return /*#__PURE__*/react.createElement("svg", login_extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "login_svg__h-6 login_svg__w-6",
    fill: "none",
    viewBox: "0 0 24 24",
    stroke: "currentColor",
    strokeWidth: 2
  }, props), login_path || (login_path = /*#__PURE__*/react.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m11 16-4-4m0 0 4-4m-4 4h14m-5 4v1a3 3 0 0 1-3 3H6a3 3 0 0 1-3-3V7a3 3 0 0 1 3-3h7a3 3 0 0 1 3 3v1"
  })));
};

/* harmony default export */ var login = (SvgLogin);
;// CONCATENATED MODULE: ./src/components/icons/menu.svg
var menu_path;

function menu_extends() { menu_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return menu_extends.apply(this, arguments); }



var SvgMenu = function SvgMenu(props) {
  return /*#__PURE__*/react.createElement("svg", menu_extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "menu_svg__h-6 menu_svg__w-6",
    fill: "none",
    viewBox: "0 0 24 24",
    stroke: "currentColor",
    strokeWidth: 2
  }, props), menu_path || (menu_path = /*#__PURE__*/react.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M4 6h16M4 12h16M4 18h16"
  })));
};

/* harmony default export */ var menu = (SvgMenu);
// EXTERNAL MODULE: ./src/components/icons/pencil.svg
var pencil = __webpack_require__(2305);
;// CONCATENATED MODULE: ./src/components/icons/support.svg
var support_path;

function support_extends() { support_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return support_extends.apply(this, arguments); }



var SvgSupport = function SvgSupport(props) {
  return /*#__PURE__*/react.createElement("svg", support_extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "support_svg__h-6 support_svg__w-6",
    fill: "none",
    viewBox: "0 0 24 24",
    stroke: "currentColor",
    strokeWidth: 2
  }, props), support_path || (support_path = /*#__PURE__*/react.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m18.364 5.636-3.536 3.536m0 5.656 3.536 3.536M9.172 9.172 5.636 5.636m3.536 9.192-3.536 3.536M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0zm-5 0a4 4 0 1 1-8 0 4 4 0 0 1 8 0z"
  })));
};

/* harmony default export */ var support = (SvgSupport);
;// CONCATENATED MODULE: ./src/components/icons/user-circle.svg
var user_circle_path;

function user_circle_extends() { user_circle_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return user_circle_extends.apply(this, arguments); }



var SvgUserCircle = function SvgUserCircle(props) {
  return /*#__PURE__*/react.createElement("svg", user_circle_extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "user-circle_svg__h-6 user-circle_svg__w-6",
    fill: "none",
    viewBox: "0 0 24 24",
    stroke: "currentColor",
    strokeWidth: 2
  }, props), user_circle_path || (user_circle_path = /*#__PURE__*/react.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M5.121 17.804A13.937 13.937 0 0 1 12 16c2.5 0 4.847.655 6.879 1.804M15 10a3 3 0 1 1-6 0 3 3 0 0 1 6 0zm6 2a9 9 0 1 1-18 0 9 9 0 0 1 18 0z"
  })));
};

/* harmony default export */ var user_circle = (SvgUserCircle);
// EXTERNAL MODULE: ./src/components/popover.tsx
var popover = __webpack_require__(314);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(1163);
// EXTERNAL MODULE: ./src/utils/dayjs.tsx
var dayjs = __webpack_require__(4752);
// EXTERNAL MODULE: ./src/components/poll/language-selector.tsx
var language_selector = __webpack_require__(4563);
;// CONCATENATED MODULE: ./src/components/preferences.tsx







const Preferences = (props)=>{
    const { t  } = (0,esm/* useTranslation */.$G)([
        "app",
        "common"
    ]);
    const { weekStartsOn , setWeekStartsOn , timeFormat , setTimeFormat  } = (0,dayjs/* useDayjs */.a)();
    const router = (0,next_router.useRouter)();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: props.className,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "mb-2 space-y-2",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "grow text-sm text-slate-500",
                        children: t("common:language")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(language_selector/* LanguageSelect */.S, {
                        className: "w-full",
                        onChange: ()=>router.reload()
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "grow space-y-2",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "mb-2 grow text-sm text-slate-500",
                                children: t("app:weekStartsOn")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "segment-button inline-flex",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                            className: (0,clsx_m/* default */.Z)({
                                                "segment-button-active": weekStartsOn === "monday"
                                            }),
                                            onClick: ()=>{
                                                setWeekStartsOn("monday");
                                            },
                                            type: "button",
                                            children: t("app:monday")
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                            className: (0,clsx_m/* default */.Z)({
                                                "segment-button-active": weekStartsOn === "sunday"
                                            }),
                                            onClick: ()=>{
                                                setWeekStartsOn("sunday");
                                            },
                                            type: "button",
                                            children: t("app:sunday")
                                        })
                                    ]
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "mb-2 grow text-sm text-slate-500",
                                children: t("app:timeFormat")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "segment-button inline-flex",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                        className: (0,clsx_m/* default */.Z)({
                                            "segment-button-active": timeFormat === "12h"
                                        }),
                                        onClick: ()=>{
                                            setTimeFormat("12h");
                                        },
                                        type: "button",
                                        children: t("app:12h")
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                        className: (0,clsx_m/* default */.Z)({
                                            "segment-button-active": timeFormat === "24h"
                                        }),
                                        onClick: ()=>{
                                            setTimeFormat("24h");
                                        },
                                        type: "button",
                                        children: t("app:24h")
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var preferences = (Preferences);

// EXTERNAL MODULE: ./src/components/dropdown.tsx + 1 modules
var dropdown = __webpack_require__(8875);
;// CONCATENATED MODULE: ./src/components/icons/logout.svg
var logout_path;

function logout_extends() { logout_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return logout_extends.apply(this, arguments); }



var SvgLogout = function SvgLogout(props) {
  return /*#__PURE__*/react.createElement("svg", logout_extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "logout_svg__h-6 logout_svg__w-6",
    fill: "none",
    viewBox: "0 0 24 24",
    stroke: "currentColor",
    strokeWidth: 2
  }, props), logout_path || (logout_path = /*#__PURE__*/react.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m17 16 4-4m0 0-4-4m4 4H7m6 4v1a3 3 0 0 1-3 3H6a3 3 0 0 1-3-3V7a3 3 0 0 1 3-3h4a3 3 0 0 1 3 3v1"
  })));
};

/* harmony default export */ var icons_logout = (SvgLogout);
;// CONCATENATED MODULE: ./src/components/icons/question-mark-circle.svg
var question_mark_circle_path;

function question_mark_circle_extends() { question_mark_circle_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return question_mark_circle_extends.apply(this, arguments); }



var SvgQuestionMarkCircle = function SvgQuestionMarkCircle(props) {
  return /*#__PURE__*/react.createElement("svg", question_mark_circle_extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "question-mark-circle_svg__h-6 question-mark-circle_svg__w-6",
    fill: "none",
    viewBox: "0 0 24 24",
    stroke: "currentColor",
    strokeWidth: 2
  }, props), question_mark_circle_path || (question_mark_circle_path = /*#__PURE__*/react.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M8.228 9c.549-1.165 2.03-2 3.772-2 2.21 0 4 1.343 4 3 0 1.4-1.278 2.575-3.006 2.907-.542.104-.994.54-.994 1.093m0 3h.01M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0z"
  })));
};

/* harmony default export */ var question_mark_circle = (SvgQuestionMarkCircle);
// EXTERNAL MODULE: ./src/components/icons/user.svg
var icons_user = __webpack_require__(7700);
;// CONCATENATED MODULE: ./src/components/layouts/standard-layout/user-dropdown.tsx











const UserDropdown = (param)=>{
    let { children , ...forwardProps } = param;
    const { logout , user  } = (0,user_provider/* useUser */.aF)();
    const { t  } = (0,esm/* useTranslation */.$G)([
        "common",
        "app"
    ]);
    const { openLoginModal  } = useLoginModal();
    const modalContext = (0,modal_provider/* useModalContext */.v)();
    if (!user) {
        return null;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(dropdown/* default */.Z, {
        ...forwardProps,
        children: [
            children,
            user.isGuest ? /*#__PURE__*/ (0,jsx_runtime.jsx)(dropdown/* DropdownItem */.h, {
                icon: question_mark_circle,
                label: t("app:whatsThis"),
                onClick: ()=>{
                    modalContext.render({
                        showClose: true,
                        content: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "w-96 max-w-full p-6 pt-28",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "absolute left-0 -top-8 w-full text-center",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "inline-flex h-20 w-20 items-center justify-center rounded-full border-8 border-white bg-gradient-to-b from-purple-400 to-primary-500",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons_user/* default */.Z, {
                                                className: "h-7 text-white"
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "text-lg font-medium leading-snug",
                                                    children: "Guest"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "text-sm text-slate-500",
                                                    children: user.shortName
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    children: t("app:guestSessionNotice")
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                        href: "https://support.rallly.co/guest-sessions",
                                        target: "_blank",
                                        rel: "noreferrer",
                                        className: "text-link",
                                        children: t("app:guestSessionReadMore")
                                    })
                                })
                            ]
                        }),
                        overlayClosable: true,
                        footer: null
                    });
                }
            }) : null,
            !user.isGuest ? /*#__PURE__*/ (0,jsx_runtime.jsx)(dropdown/* DropdownItem */.h, {
                href: "/profile",
                icon: icons_user/* default */.Z,
                label: t("app:yourProfile")
            }) : null,
            user.isGuest ? /*#__PURE__*/ (0,jsx_runtime.jsx)(dropdown/* DropdownItem */.h, {
                icon: login,
                label: t("app:login"),
                onClick: openLoginModal
            }) : null,
            /*#__PURE__*/ (0,jsx_runtime.jsx)(dropdown/* DropdownItem */.h, {
                icon: icons_logout,
                label: user.isGuest ? t("app:forgetMe") : t("app:logout"),
                onClick: ()=>{
                    if (user === null || user === void 0 ? void 0 : user.isGuest) {
                        modalContext.render({
                            title: t("app:areYouSure"),
                            description: t("app:endingGuestSessionNotice"),
                            onOk: logout,
                            okButtonProps: {
                                type: "danger"
                            },
                            okText: t("app:endSession"),
                            cancelText: t("app:cancel")
                        });
                    } else {
                        logout();
                    }
                }
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/layouts/standard-layout/mobile-navigation.tsx



















const MobileNavigation = (props)=>{
    const { user , isUpdating  } = (0,user_provider/* useUser */.aF)();
    const { t  } = (0,esm/* useTranslation */.$G)([
        "common",
        "app"
    ]);
    const [isPinned, setIsPinned] = react.useState(false);
    react.useEffect(()=>{
        const scrollHandler = ()=>{
            if (window.scrollY > 0) {
                setIsPinned(true);
            } else {
                setIsPinned(false);
            }
        };
        window.addEventListener("scroll", scrollHandler);
        return ()=>{
            window.removeEventListener("scroll", scrollHandler);
        };
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (0,clsx_m/* default */.Z)("sticky top-0 z-40 flex h-12 w-full shrink-0 items-center justify-between border-b p-3 transition-all", {
            "bg-gray-50/75 shadow-sm backdrop-blur-md ": isPinned,
            "border-transparent bg-gray-50/0 shadow-none": !isPinned
        }, props.className),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(popover/* Popover */.J2, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(popover/* PopoverTrigger */.xo, {
                            asChild: true,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                                role: "button",
                                type: "button",
                                className: "group flex items-center rounded-md px-2 py-1 font-medium text-slate-600 transition-colors hover:bg-gray-200 hover:text-slate-600 hover:no-underline active:bg-gray-300",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(menu, {
                                        className: "mr-2 w-5 group-hover:text-primary-500"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Logo, {})
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(popover/* PopoverContent */.yk, {
                            align: "start",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AppMenu, {})
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex items-center",
                children: [
                    user ? null : /*#__PURE__*/ (0,jsx_runtime.jsxs)(LoginLink, {
                        className: "flex w-full cursor-pointer items-center space-x-2 whitespace-nowrap rounded-md px-2 py-1 font-medium text-slate-600 transition-colors hover:bg-gray-200 hover:text-slate-600 hover:no-underline active:bg-gray-300",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(login, {
                                className: "h-5 opacity-75"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "inline-block",
                                children: t("app:login")
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(AnimatePresence/* AnimatePresence */.M, {
                        initial: false,
                        children: user ? /*#__PURE__*/ (0,jsx_runtime.jsx)(UserDropdown, {
                            placement: "bottom-end",
                            trigger: /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                                role: "button",
                                "data-testid": "user",
                                className: (0,clsx_m/* default */.Z)("group inline-flex w-full items-center space-x-2 rounded-lg px-2 py-1 text-left transition-colors hover:bg-slate-500/10 active:bg-slate-500/20", {
                                    "opacity-50": isUpdating
                                }),
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "relative shrink-0",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(user_circle, {
                                            className: "w-5 opacity-75 group-hover:text-primary-500 group-hover:opacity-100"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "max-w-[120px] truncate font-medium xs:block",
                                        children: user.isGuest ? t("app:guest") : user.shortName
                                    })
                                ]
                            })
                        }) : null
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(popover/* Popover */.J2, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(popover/* PopoverTrigger */.xo, {
                                asChild: true,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                                    role: "button",
                                    type: "button",
                                    className: "group flex items-center whitespace-nowrap rounded-md px-2 py-1 font-medium text-slate-600 transition-colors hover:bg-gray-200 hover:text-slate-600 hover:no-underline active:bg-gray-300",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(adjustments, {
                                            className: "h-5 opacity-75 group-hover:text-primary-500"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: "ml-2 hidden sm:block",
                                            children: t("app:preferences")
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(popover/* PopoverContent */.yk, {
                                align: "end",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(preferences, {
                                    className: "p-2"
                                })
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
const AppMenu = (param)=>{
    let { className  } = param;
    const { t  } = (0,esm/* useTranslation */.$G)([
        "common",
        "app"
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (0,clsx_m/* default */.Z)("space-y-1", className),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)((link_default()), {
                href: "/",
                className: "flex cursor-pointer items-center space-x-2 whitespace-nowrap rounded-md px-2 py-1 pr-4 font-medium text-slate-600 transition-colors hover:bg-slate-50 hover:text-slate-600 hover:no-underline active:bg-gray-300",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(home, {
                        className: "h-5 opacity-75 "
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: "inline-block",
                        children: t("app:home")
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)((link_default()), {
                href: "/new",
                className: "flex cursor-pointer items-center space-x-2 whitespace-nowrap rounded-md px-2 py-1 pr-4 font-medium text-slate-600 transition-colors hover:bg-slate-50 hover:text-slate-600 hover:no-underline active:bg-gray-300",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(pencil/* default */.Z, {
                        className: "h-5 opacity-75 "
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: "inline-block",
                        children: t("app:createNew")
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                target: "_blank",
                href: "https://support.rallly.co",
                className: "flex cursor-pointer items-center space-x-2 whitespace-nowrap rounded-md px-2 py-1 pr-4 font-medium text-slate-600 transition-colors hover:bg-slate-50 hover:text-slate-600 hover:no-underline active:bg-gray-300",
                rel: "noreferrer",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(support, {
                        className: "h-5 opacity-75"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: "inline-block",
                        children: t("common:support")
                    })
                ]
            })
        ]
    });
};


/***/ }),

/***/ 4563:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "S": function() { return /* binding */ LanguageSelect; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(6010);
/* harmony import */ var js_cookie__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1955);
/* harmony import */ var next_i18next__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(692);




const LanguageSelect = (param)=>{
    let { className , onChange  } = param;
    const { i18n  } = (0,next_i18next__WEBPACK_IMPORTED_MODULE_2__/* .useTranslation */ .$G)("common");
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("select", {
        className: (0,clsx__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)("input", className),
        defaultValue: i18n.language,
        onChange: (e)=>{
            js_cookie__WEBPACK_IMPORTED_MODULE_1__/* ["default"].set */ .Z.set("NEXT_LOCALE", e.target.value, {
                expires: 365
            });
            onChange === null || onChange === void 0 ? void 0 : onChange(e.target.value);
        },
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("option", {
                value: "en",
                children: "English"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("option", {
                value: "ca",
                children: "Catal\xe0"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("option", {
                value: "cs",
                children: "Česky"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("option", {
                value: "zh",
                children: "汉语"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("option", {
                value: "da",
                children: "Dansk"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("option", {
                value: "de",
                children: "Deutsch"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("option", {
                value: "es",
                children: "Espa\xf1ol"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("option", {
                value: "fi",
                children: "Suomi"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("option", {
                value: "fr",
                children: "Fran\xe7ais"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("option", {
                value: "hr",
                children: "Hrvatski"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("option", {
                value: "it",
                children: "Italiano"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("option", {
                value: "ko",
                children: "한국어"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("option", {
                value: "hu",
                children: "Magyar"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("option", {
                value: "nl",
                children: "Nederlands"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("option", {
                value: "pl",
                children: "Polski"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("option", {
                value: "pt",
                children: "Portugu\xeas"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("option", {
                value: "pt-BR",
                children: "Portugu\xeas - Brasil"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("option", {
                value: "ru",
                children: "Pусский"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("option", {
                value: "sk",
                children: "Slovenčina"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("option", {
                value: "sv",
                children: "Svenska"
            })
        ]
    });
};


/***/ }),

/***/ 314:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "J2": function() { return /* binding */ Popover; },
/* harmony export */   "xo": function() { return /* binding */ PopoverTrigger; },
/* harmony export */   "yk": function() { return /* binding */ PopoverContent; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var _radix_ui_react_popover__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(6055);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(6010);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
"use client";




const Popover = _radix_ui_react_popover__WEBPACK_IMPORTED_MODULE_2__/* .Root */ .fC;
const PopoverTrigger = _radix_ui_react_popover__WEBPACK_IMPORTED_MODULE_2__/* .Trigger */ .xz;
const PopoverContent = /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_1__.forwardRef((param, ref)=>/*#__PURE__*/ {
    let { className , align ="center" , sideOffset =4 , ...props } = param;
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_radix_ui_react_popover__WEBPACK_IMPORTED_MODULE_2__/* .Portal */ .h_, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_radix_ui_react_popover__WEBPACK_IMPORTED_MODULE_2__/* .Content */ .VY, {
            ref: ref,
            align: align,
            sideOffset: sideOffset,
            className: (0,clsx__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)("z-50 animate-popIn rounded-md border bg-white p-1 shadow-md outline-none", {
                "origin-top-left": align === "start",
                "origin-top-right": align === "end"
            }, className),
            ...props
        })
    });
});
PopoverContent.displayName = _radix_ui_react_popover__WEBPACK_IMPORTED_MODULE_2__/* .Content.displayName */ .VY.displayName;



/***/ }),

/***/ 4752:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "L": function() { return /* binding */ DayjsProvider; },
/* harmony export */   "a": function() { return /* binding */ useDayjs; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var dayjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7484);
/* harmony import */ var dayjs__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(dayjs__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var dayjs_plugin_duration__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(1646);
/* harmony import */ var dayjs_plugin_duration__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(dayjs_plugin_duration__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var dayjs_plugin_isBetween__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(6607);
/* harmony import */ var dayjs_plugin_isBetween__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(dayjs_plugin_isBetween__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var dayjs_plugin_isSameOrBefore__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(7412);
/* harmony import */ var dayjs_plugin_isSameOrBefore__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(dayjs_plugin_isSameOrBefore__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var dayjs_plugin_localeData__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(6036);
/* harmony import */ var dayjs_plugin_localeData__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(dayjs_plugin_localeData__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var dayjs_plugin_localizedFormat__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(6176);
/* harmony import */ var dayjs_plugin_localizedFormat__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(dayjs_plugin_localizedFormat__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var dayjs_plugin_minMax__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(7181);
/* harmony import */ var dayjs_plugin_minMax__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(dayjs_plugin_minMax__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var dayjs_plugin_relativeTime__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(4110);
/* harmony import */ var dayjs_plugin_relativeTime__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(dayjs_plugin_relativeTime__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var dayjs_plugin_timezone__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(9387);
/* harmony import */ var dayjs_plugin_timezone__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(dayjs_plugin_timezone__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var dayjs_plugin_utc__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(178);
/* harmony import */ var dayjs_plugin_utc__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(dayjs_plugin_utc__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var next_i18next__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(692);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(7294);
/* harmony import */ var react_use__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(584);
/* harmony import */ var react_use__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(5533);
/* harmony import */ var _components_use_required_context__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(8355);















const dayjsLocales = {
    en: {
        weekStartsOn: "monday",
        timeFormat: "12h",
        import: ()=>__webpack_require__.e(/* import() */ 5054).then(__webpack_require__.t.bind(__webpack_require__, 5054, 23))
    },
    es: {
        weekStartsOn: "monday",
        timeFormat: "24h",
        import: ()=>__webpack_require__.e(/* import() */ 7763).then(__webpack_require__.t.bind(__webpack_require__, 7763, 23))
    },
    ca: {
        weekStartsOn: "monday",
        timeFormat: "24h",
        import: ()=>__webpack_require__.e(/* import() */ 3646).then(__webpack_require__.t.bind(__webpack_require__, 3646, 23))
    },
    da: {
        weekStartsOn: "monday",
        timeFormat: "24h",
        import: ()=>__webpack_require__.e(/* import() */ 7427).then(__webpack_require__.t.bind(__webpack_require__, 7427, 23))
    },
    de: {
        weekStartsOn: "monday",
        timeFormat: "24h",
        import: ()=>__webpack_require__.e(/* import() */ 790).then(__webpack_require__.t.bind(__webpack_require__, 790, 23))
    },
    fi: {
        weekStartsOn: "monday",
        timeFormat: "24h",
        import: ()=>__webpack_require__.e(/* import() */ 7822).then(__webpack_require__.t.bind(__webpack_require__, 7822, 23))
    },
    fr: {
        weekStartsOn: "monday",
        timeFormat: "24h",
        import: ()=>__webpack_require__.e(/* import() */ 6023).then(__webpack_require__.t.bind(__webpack_require__, 6023, 23))
    },
    hr: {
        weekStartsOn: "monday",
        timeFormat: "24h",
        import: ()=>__webpack_require__.e(/* import() */ 6257).then(__webpack_require__.t.bind(__webpack_require__, 6257, 23))
    },
    it: {
        weekStartsOn: "monday",
        timeFormat: "24h",
        import: ()=>__webpack_require__.e(/* import() */ 5551).then(__webpack_require__.t.bind(__webpack_require__, 5551, 23))
    },
    sv: {
        weekStartsOn: "monday",
        timeFormat: "24h",
        import: ()=>__webpack_require__.e(/* import() */ 1876).then(__webpack_require__.t.bind(__webpack_require__, 1876, 23))
    },
    sk: {
        weekStartsOn: "monday",
        timeFormat: "24h",
        import: ()=>__webpack_require__.e(/* import() */ 5627).then(__webpack_require__.t.bind(__webpack_require__, 5627, 23))
    },
    cs: {
        weekStartsOn: "monday",
        timeFormat: "24h",
        import: ()=>__webpack_require__.e(/* import() */ 8507).then(__webpack_require__.t.bind(__webpack_require__, 8507, 23))
    },
    pl: {
        weekStartsOn: "monday",
        timeFormat: "24h",
        import: ()=>__webpack_require__.e(/* import() */ 1987).then(__webpack_require__.t.bind(__webpack_require__, 1987, 23))
    },
    pt: {
        weekStartsOn: "monday",
        timeFormat: "24h",
        import: ()=>__webpack_require__.e(/* import() */ 5001).then(__webpack_require__.t.bind(__webpack_require__, 5001, 23))
    },
    "pt-BR": {
        weekStartsOn: "sunday",
        timeFormat: "24h",
        import: ()=>__webpack_require__.e(/* import() */ 7548).then(__webpack_require__.t.bind(__webpack_require__, 7548, 23))
    },
    ru: {
        weekStartsOn: "monday",
        timeFormat: "24h",
        import: ()=>__webpack_require__.e(/* import() */ 600).then(__webpack_require__.t.bind(__webpack_require__, 600, 23))
    },
    ko: {
        weekStartsOn: "sunday",
        timeFormat: "12h",
        import: ()=>__webpack_require__.e(/* import() */ 9132).then(__webpack_require__.t.bind(__webpack_require__, 9132, 23))
    },
    nl: {
        weekStartsOn: "monday",
        timeFormat: "24h",
        import: ()=>__webpack_require__.e(/* import() */ 9182).then(__webpack_require__.t.bind(__webpack_require__, 9182, 23))
    },
    hu: {
        weekStartsOn: "monday",
        timeFormat: "24h",
        import: ()=>__webpack_require__.e(/* import() */ 8562).then(__webpack_require__.t.bind(__webpack_require__, 8562, 23))
    },
    zh: {
        weekStartsOn: "monday",
        timeFormat: "24h",
        import: ()=>__webpack_require__.e(/* import() */ 2009).then(__webpack_require__.t.bind(__webpack_require__, 2009, 23))
    }
};
dayjs__WEBPACK_IMPORTED_MODULE_1___default().extend((dayjs_plugin_localizedFormat__WEBPACK_IMPORTED_MODULE_6___default()));
dayjs__WEBPACK_IMPORTED_MODULE_1___default().extend((dayjs_plugin_relativeTime__WEBPACK_IMPORTED_MODULE_8___default()));
dayjs__WEBPACK_IMPORTED_MODULE_1___default().extend((dayjs_plugin_localeData__WEBPACK_IMPORTED_MODULE_5___default()));
dayjs__WEBPACK_IMPORTED_MODULE_1___default().extend((dayjs_plugin_isSameOrBefore__WEBPACK_IMPORTED_MODULE_4___default()));
dayjs__WEBPACK_IMPORTED_MODULE_1___default().extend((dayjs_plugin_isBetween__WEBPACK_IMPORTED_MODULE_3___default()));
dayjs__WEBPACK_IMPORTED_MODULE_1___default().extend((dayjs_plugin_minMax__WEBPACK_IMPORTED_MODULE_7___default()));
dayjs__WEBPACK_IMPORTED_MODULE_1___default().extend((dayjs_plugin_utc__WEBPACK_IMPORTED_MODULE_10___default()));
dayjs__WEBPACK_IMPORTED_MODULE_1___default().extend((dayjs_plugin_timezone__WEBPACK_IMPORTED_MODULE_9___default()));
dayjs__WEBPACK_IMPORTED_MODULE_1___default().extend((dayjs_plugin_duration__WEBPACK_IMPORTED_MODULE_2___default()));
const DayjsContext = /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_12__.createContext(null);
const useDayjs = ()=>{
    return (0,_components_use_required_context__WEBPACK_IMPORTED_MODULE_13__/* .useRequiredContext */ .a)(DayjsContext);
};
const DayjsProviderInner = (param)=>{
    let { children  } = param;
    const { i18n  } = (0,next_i18next__WEBPACK_IMPORTED_MODULE_11__/* .useTranslation */ .$G)();
    // Using language instead of router.locale because when transitioning from homepage to
    // the app via <Link locale={false}> it will be set to "en" instead of the current locale.
    const localeConfig = dayjsLocales[i18n.language];
    const [weekStartsOn = localeConfig.weekStartsOn, setWeekStartsOn] = (0,react_use__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z)("rallly-week-starts-on");
    const [timeFormat = localeConfig.timeFormat, setTimeFormat] = (0,react_use__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z)("rallly-time-format");
    const { value: dayjsLocale  } = (0,react_use__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z)(async ()=>{
        return await localeConfig.import();
    }, [
        localeConfig
    ]);
    if (!dayjsLocale) {
        // wait for locale to load before rendering content
        return null;
    }
    dayjs__WEBPACK_IMPORTED_MODULE_1___default().locale({
        ...dayjsLocale,
        weekStart: weekStartsOn ? weekStartsOn === "monday" ? 1 : 0 : dayjsLocale.weekStart,
        formats: localeConfig.timeFormat !== timeFormat ? {
            ...dayjsLocale.formats,
            LT: timeFormat === "12h" ? "h:mm A" : "HH:mm"
        } : dayjsLocale.formats
    });
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(DayjsContext.Provider, {
        value: {
            dayjs: (dayjs__WEBPACK_IMPORTED_MODULE_1___default()),
            weekStartsOn: weekStartsOn !== null && weekStartsOn !== void 0 ? weekStartsOn : localeConfig.weekStartsOn,
            timeFormat: timeFormat !== null && timeFormat !== void 0 ? timeFormat : localeConfig.timeFormat,
            setWeekStartsOn,
            setTimeFormat
        },
        children: children
    });
};
const DayjsProvider = (param)=>{
    let { children  } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(DayjsProviderInner, {
        children: children
    });
};


/***/ }),

/***/ 6708:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "U": function() { return /* binding */ stopPropagation; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7294);

const stopPropagation = (e)=>e.stopPropagation();


/***/ })

}]);